export default {
    something_wrong:"ប្រតិបត្តិការមិនជោគជ័យ",
    please_input_amount :"សូមបញ្ចូលទឹកប្រាក់",
    game_close:"ការភ្នាល់បានបិទ សូមរង់ចាំ, អរគុណ",
    processing_previous_betting:"កំពុងដំណើរការប៉ុងចាស់របស់លោកអ្នក...",
    SUCCESS:"ប្រតិបត្តិការជោគជ័យ"
};
